export default "__VITE_ASSET__lagPzFCh__"